var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TitleWithBackButton',{attrs:{"title":"Gestione Presenze","back-route":"Homepage","icon":"mdi-calendar-account"}}),_c('PresenceHome')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }